/* bioactive-lp.js — BioActive+ Landing Page (Shopify + Recharge) */

var BALP = window.BALP || {};
var baLpStack  = null;
var baLpMode   = 'sub';
var baLpProto  = false;

/* ── helpers ─────────────────────────────────────────────── */
function lpGet(id)    { return document.getElementById(id); }
function lpAll(sel)   { return document.querySelectorAll(sel); }
function lpSet(id, v) { var el = lpGet(id); if (el) el.textContent = v; }
function lpQ(sel)     { return document.querySelector(sel); }

function lpGetStack() {
  if (!BALP.stacks) return null;
  return BALP.stacks.find(function(s) { return String(s.variantId) === baLpStack; }) || BALP.stacks[0];
}

/* ── announce ticker ─────────────────────────────────────── */
function baLpInitAnnounce() {
  var msgs = lpAll('.ba-lp .ba-announce-msg');
  if (!msgs.length) return;
  var cur = 0;
  msgs[0].classList.add('on');
  setInterval(function() {
    msgs[cur].classList.remove('on');
    cur = (cur + 1) % msgs.length;
    msgs[cur].classList.add('on');
  }, 3000);
}

/* ── gallery (swipe carousel) ────────────────────────────── */
function baLpInitGallery() {
  var track = lpQ('.ba-lp .ba-gallery-track');
  var dots  = lpAll('.ba-lp .ba-gallery-dot');
  if (!track || !dots.length) return;

  function setDot(idx) {
    dots.forEach(function(d, i) { d.classList.toggle('on', i === idx); });
  }

  track.addEventListener('scroll', function() {
    var idx = Math.round(track.scrollLeft / track.clientWidth);
    setDot(idx);
  }, { passive: true });

  dots.forEach(function(dot, i) {
    dot.addEventListener('click', function() {
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    });
  });

  var playBtn = lpQ('.ba-lp .ba-gallery-play');
  if (playBtn) {
    playBtn.addEventListener('click', function() {
      var last = track.children.length - 1;
      track.scrollTo({ left: last * track.clientWidth, behavior: 'smooth' });
    });
  }

  setDot(0);
}

/* ── stack selection ─────────────────────────────────────── */
function baLpSelectStack(stackId) {
  baLpStack = String(stackId);
  lpAll('.ba-lp .ba-stack-card').forEach(function(card) {
    card.classList.toggle('on', String(card.dataset.stack) === baLpStack);
  });
  baLpUpdatePrices();
}

/* ── mode toggle ─────────────────────────────────────────── */
function baLpSetMode(mode) {
  baLpMode = mode;
  lpAll('.ba-lp .ba-mode-btn').forEach(function(btn) {
    btn.classList.toggle('on', btn.dataset.mode === mode);
  });
  var badge = lpQ('.ba-lp .ba-save-badge');
  if (badge) badge.style.visibility = mode === 'sub' ? 'hidden' : 'visible';
  baLpUpdatePrices();
}

/* ── price update ────────────────────────────────────────── */
function baLpUpdatePrices() {
  var s = lpGetStack();
  if (!s) return;
  var isSub  = baLpMode === 'sub';
  var priceF = isSub ? s.subPriceF  : s.priceF;
  var saveF  = isSub ? s.subSaveF   : s.saveF;
  var instF  = isSub ? s.installSubF : s.installOtF;
  var lbl    = s.name + ' · ' + (isSub ? 'Subscription' : 'One-time');

  lpSet('ba-lp-price-lbl',   lbl);
  lpSet('ba-lp-price-now',   priceF);
  lpSet('ba-lp-price-was',   s.wasF);
  lpSet('ba-lp-save-chip',   'Save ' + saveF);
  lpSet('ba-lp-cta-price',   priceF);
  lpSet('ba-lp-sticky-price', priceF);
  lpSet('ba-lp-sticky-was',  s.wasF);
  lpSet('ba-lp-sticky-save', 'You save ' + saveF);
  lpSet('ba-lp-install-amt', 'Or 4 × ' + instF + ' with');
}

/* ── why cards ───────────────────────────────────────────── */
function baLpInitWhy() {
  lpAll('.ba-lp .ba-why-card').forEach(function(card) {
    card.addEventListener('click', function() {
      var isOn = card.classList.contains('on');
      lpAll('.ba-lp .ba-why-card').forEach(function(c) { c.classList.remove('on'); });
      if (!isOn) card.classList.add('on');
    });
  });
  var first = lpQ('.ba-lp .ba-why-card');
  if (first) first.classList.add('on');
}

/* ── UGC play/pause ──────────────────────────────────────── */
function baLpInitUGC() {
  lpAll('.ba-lp .ba-ugc-card').forEach(function(card) {
    card.addEventListener('click', function() {
      var playing = card.classList.toggle('playing');
      var prog = card.querySelector('.ba-ugc-prog');
      var eq   = card.querySelector('.ba-eq');
      var tri  = card.querySelector('.ba-ugc-tri');
      if (eq)  eq.style.display  = playing ? 'inline-flex' : 'none';
      if (tri) tri.style.display = playing ? 'none' : 'block';
      if (prog) {
        if (playing) {
          prog.style.transition = 'width 9s linear';
          prog.classList.add('playing');
        } else {
          prog.classList.remove('playing');
          prog.style.transition = 'none';
          prog.style.width = '0%';
        }
      }
    });
  });
}

/* ── timeline ────────────────────────────────────────────── */
function baLpSetPhase(idx) {
  var dots  = lpAll('.ba-lp .ba-tl-dot-btn');
  var total = dots.length;
  var pct   = total > 1 ? (idx / (total - 1)) * 100 : 0;
  var fill  = lpGet('ba-lp-tl-fill');
  if (fill) fill.style.width = 'calc(' + pct + '% - ' + (pct / 100 * 24).toFixed(1) + 'px + 12px)';
  dots.forEach(function(btn, i) {
    var dot = btn.querySelector('.ba-tl-dot');
    if (dot) {
      dot.classList.toggle('done',   i <= idx);
      dot.classList.toggle('active', i === idx);
    }
    btn.classList.toggle('active', i === idx);
  });
  lpAll('.ba-lp .ba-tl-panel').forEach(function(panel, i) {
    panel.classList.toggle('on', i === idx);
  });
}

/* ── science tabs ────────────────────────────────────────── */
function baLpSetSciTab(tabId) {
  lpAll('.ba-lp .ba-sci-tab').forEach(function(t) {
    t.classList.toggle('on', t.dataset.tab === tabId);
  });
  lpAll('.ba-lp .ba-sci-panel').forEach(function(p) {
    p.classList.toggle('on', p.dataset.tab === tabId);
  });
  if (tabId === 'comparison') {
    setTimeout(function() {
      lpAll('.ba-lp .ba-bar-fill').forEach(function(bar) {
        bar.style.width = (bar.dataset.w || '0') + '%';
      });
    }, 60);
  }
}

/* ── FAQ ─────────────────────────────────────────────────── */
function baLpToggleFaq(btn) {
  var item   = btn.closest('.ba-faq-item');
  var isOpen = item.classList.contains('open');
  lpAll('.ba-lp .ba-faq-item').forEach(function(f) { f.classList.remove('open'); });
  if (!isOpen) item.classList.add('open');
}

/* ── protocol upsell ─────────────────────────────────────── */
function baLpToggleProto() {
  baLpProto = !baLpProto;
  var btn = lpQ('.ba-lp .ba-proto-btn');
  if (!btn) return;
  btn.classList.toggle('added', baLpProto);
  btn.innerHTML = baLpProto
    ? '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12.5 4.5 4.5L19 6.5"/></svg> Added to your order'
    : '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg> Add full protocol — save AED 179';
}

/* ── sticky bar ──────────────────────────────────────────── */
function baLpInitSticky() {
  var anchor = lpGet('ba-lp-buy-anchor');
  var bar    = lpQ('.ba-lp .ba-sticky');
  if (!anchor || !bar) return;
  window.addEventListener('scroll', function() {
    var b      = anchor.getBoundingClientRect().bottom;
    var docEnd = document.body.scrollHeight - window.innerHeight - 400;
    bar.classList.toggle('show', b < 120 && window.scrollY < docEnd);
  }, { passive: true });
}

/* ── scroll reveal ───────────────────────────────────────── */
function baLpInitReveal() {
  var els = lpAll('.ba-lp .ba-reveal');
  if (!els.length || !window.IntersectionObserver) {
    els.forEach(function(el) { el.classList.add('shown'); });
    return;
  }
  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (!e.isIntersecting) return;
      var delay = parseFloat(e.target.dataset.delay || 0) * 1000;
      setTimeout(function() { e.target.classList.add('shown'); }, delay);
      io.unobserve(e.target);
    });
  }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
  els.forEach(function(el) { io.observe(el); });
}

/* ── scroll to reviews ───────────────────────────────────── */
function baLpScrollToReviews() {
  var target = lpGet('ba-lp-reviews');
  if (!target) return;
  var hdr = (document.querySelector('sticky-header') || document.querySelector('.header-wrapper') || {}).offsetHeight || 0;
  window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - hdr - 8, behavior: 'smooth' });
}

/* ── toast ───────────────────────────────────────────────── */
function baLpShowToast(msg) {
  var toast = lpQ('.ba-lp .ba-toast');
  if (!toast) return;
  var txt = toast.querySelector('.ba-toast-msg');
  if (txt) txt.textContent = msg || 'Added to cart ✓';
  toast.classList.add('show');
  clearTimeout(window.__baLpToastTimer);
  window.__baLpToastTimer = setTimeout(function() { toast.classList.remove('show'); }, 1900);
}

/* ── cart count ──────────────────────────────────────────── */
function baLpUpdateCartCount(count) {
  document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(function(el) { el.textContent = count; });
  document.querySelectorAll('[data-cart-count]').forEach(function(el) { el.textContent = count; });
  var badge = lpGet('ba-lp-cart-badge');
  if (badge) { badge.textContent = count; badge.style.display = count > 0 ? 'grid' : 'none'; }
}

/* ── add to cart ─────────────────────────────────────────── */
function baLpAddToCart() {
  var s = lpGetStack();
  if (!s) { baLpShowToast('Please select a product'); return; }

  var item = { id: s.variantId, quantity: 1 };
  if (baLpMode === 'sub' && BALP.sellingPlanId) {
    item.selling_plan = BALP.sellingPlanId;
  }

  var btns = lpAll('.ba-lp .ba-cta, .ba-lp .ba-sticky-cta');
  btns.forEach(function(b) { b.setAttribute('disabled', 'disabled'); });

  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  fetch(root + 'cart/add.js', {
    method:  'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body:    JSON.stringify({ items: [item] })
  })
  .then(function(r) { return r.json(); })
  .then(function(data) {
    btns.forEach(function(b) { b.removeAttribute('disabled'); });
    if (data.status) { baLpShowToast(data.description || 'Could not add to cart'); return; }
    baLpShowToast('Added to cart ✓');
    return fetch('/cart.js').then(function(r) { return r.json(); });
  })
  .then(function(cart) {
    if (cart && cart.item_count != null) baLpUpdateCartCount(cart.item_count);
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  })
  .catch(function() {
    btns.forEach(function(b) { b.removeAttribute('disabled'); });
    baLpShowToast('Error — please try again');
  });
}

/* ── init ────────────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', function() {
  if (!lpQ('.ba-lp')) return;

  if (BALP.stacks && BALP.stacks.length > 0) {
    var def = BALP.stacks.find(function(s) { return s.badge === 'Most Popular'; });
    if (!def && BALP.stacks.length > 1) def = BALP.stacks[1];
    if (!def) def = BALP.stacks[0];
    baLpStack = String(def.variantId);
    baLpSelectStack(baLpStack);
  }

  baLpSetMode('sub');
  baLpInitAnnounce();
  baLpInitGallery();
  baLpInitWhy();
  baLpInitUGC();
  baLpSetPhase(2);
  baLpSetSciTab('ingredients');
  baLpInitSticky();
  baLpInitReveal();

  /* open first FAQ */
  var firstFaq = lpQ('.ba-lp .ba-faq-item');
  if (firstFaq) firstFaq.classList.add('open');
});
